import isNil from 'lodash/isNil'

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Checks if a value is empty, null or undefined
 *
 * @param {unknown} value - The value to check.
 * @returns {boolean} True if the value is empty, null or undefined, false otherwise.
 */
export const isNilOrEmpty = (value: unknown): boolean => {
  return value === '' || isNil(value)
}
